module.exports = __webpack_public_path__ + "img/Jordan.21743ea1.gif";